<ul *ngIf="breadcrumbs.length" class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs">
    <a [routerLink]="breadcrumb.url">{{ breadcrumb.label | translate }}</a>
  </li>
</ul>
